export const CONTACT = {
  brand: "OKA VTC",
  phone: "0623880881",
  phoneDisplay: "06 23 88 08 81",
  phoneIntl: "+33623880881",
  email: "contact@okavtc.com",
  zone: "Région lyonnaise",
};

export const IMAGES = {
  hero: "/images/hero.jpg",
  side: "/images/side.jpg",
  interior: "/images/interior.jpg",
  chauffeur: "/images/chauffeur.jpg",
  wedding: "/images/wedding.jpg",
  airport: "/images/airport.jpg",
  affaires: "/images/affaires.jpg",
};

export const SERVICES = [
  {
    key: "aeroport",
    label: "Trajet Aéroport & Gare",
    title: "Transferts Aéroport",
    desc: "Lyon Saint-Exupéry, Genève, gares Part-Dieu & Perrache. Suivi des vols, accueil personnalisé et ponctualité garantie.",
    image: IMAGES.airport,
  },
  {
    key: "disposition",
    label: "Mise à disposition",
    title: "Chauffeur à disposition",
    desc: "Un chauffeur dédié à l'heure ou à la journée pour vos rendez-vous d'affaires, déplacements professionnels ou soirées.",
    image: IMAGES.chauffeur,
  },
  {
    key: "mariage",
    label: "Événement & Mariage",
    title: "Véhicule décoré Mariage",
    desc: "Une Peugeot 508 SW blanche élégamment décorée pour votre grand jour. Un écrin raffiné pour vos plus beaux moments.",
    image: IMAGES.wedding,
  },
  {
    key: "autre",
    label: "Sur-mesure",
    title: "Autres prestations",
    desc: "Événements, longue distance, soirées. Dites-moi votre besoin, je conçois un trajet à votre mesure.",
    image: IMAGES.side,
  },
  {
    key: "affaires",
    label: "Rendez-vous d'affaires",
    title: "Trajets professionnels",
    desc: "Rendez-vous clients, roadshows, déplacements d'affaires : ponctualité et discrétion pour votre image professionnelle.",
    image: IMAGES.affaires,
  },
];

export const MANIFESTO = [
  { n: "01", icon: "clock", title: "La ponctualité, sans compromis", body: "Chaque minute compte. J'anticipe le trafic lyonnais et arrive toujours en avance pour un départ serein.", image: IMAGES.hero },
  { n: "02", icon: "car", title: "Un véhicule d'exception", body: "Peugeot 508 SW Hybrid 180 Allure 2025, immaculée, silencieuse et hybride. Le confort d'une berline haut de gamme.", image: IMAGES.side },
  { n: "03", icon: "sparkles", title: "Un service sur-mesure", body: "Eau, chargeurs, discrétion et attention à chaque détail. Un trajet pensé entièrement autour de vous.", image: IMAGES.chauffeur },
];
